'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _HubsToPath;

var _AllowedHubs = require('./AllowedHubs');

var _AllowedHubs2 = _interopRequireDefault(_AllowedHubs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var HubsToPath = (_HubsToPath = {}, _defineProperty(_HubsToPath, _AllowedHubs2.default.HUBS_CAMPAIGN, 'hubs_campaign'), _defineProperty(_HubsToPath, _AllowedHubs2.default.HUBS_CTA, 'hubs_cta'), _HubsToPath);

exports.default = HubsToPath;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/signup-ui-core/static-1.15/js/constants/HubsToPath.js
// module id = 428
// module chunks = 0